import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorNotification, PrimaryCardButton } from '@cb/apricot-react';
import { CircularProgress, Grid } from '@mui/material';

import { SchoolSearchForm, Typography } from 'src/components';
import { DISearchResult, NewScoreSendModal } from 'src/di/components';
import { useSearchDI } from 'src/di/apis';
import { TSchoolSearchCondition } from 'src/types';
import { APP_URLS } from 'src/constants';
import { useToasts } from 'src/hooks';

const DISearch: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state as any;
  const searchParams = state?.search;

  const [name, setName] = useState(searchParams?.OrgName || '');
  const [country, setCountry] = useState(searchParams?.Country || '');
  const [zip, setZip] = useState(searchParams?.Zip || '');
  const [searched, setSearched] = useState(false);

  const { data, total, isLoading, failure, search } = useSearchDI();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { render: renderToasts, toastErrorMessage } = useToasts();

  const submitSearch = (params: TSchoolSearchCondition) => {
    setSearched(true);
    setCountry(params.Country);
    setZip(params.Zip);
    setName(params.OrgName);
    search(params);
  };
  // TO-DO: Setup existing AI interface for data standards
  // will translate the API response into common data interface

  useEffect(() => {
    window.scrollTo(0, 0);
    country !== '' && submitSearch({ OrgName: name, Zip: zip, Country: country });
  }, []);

  const searchErrorMessage = failure;
  return (
    <Grid container>
      {
        <Grid item xs={12}>
          <>
            <div >
              <Typography variant="h5">College Board Score Send Code Search</Typography>
            </div>
            <br />
            <div style={{ marginBottom: '20px' }}>
              <SchoolSearchForm init={{ OrgName: name, Zip: zip, Country: country }} onSubmit={submitSearch} />
            </div>
            <NewScoreSendModal
              isOpen={isCreateModalOpen}
              onClose={() => setIsCreateModalOpen(false)}
              onComplete={() => { setIsCreateModalOpen(false); navigate(APP_URLS.DIHOME); }}
            />
            {isLoading && (
              <Grid container item xs={12} justifyContent="center">
                <CircularProgress color="secondary" />
              </Grid>
            )}
            {searchErrorMessage && (
              <Grid item xs={12}>
                {/* @ts-ignore */}
                <ErrorNotification dismissible title="Error">
                  {searchErrorMessage}
                </ErrorNotification>
              </Grid>
            )}
            {renderToasts()}
            {total > 0 && (
              <Grid item xs={12} style={{ marginBottom: '10px' }}>
                <Typography align="center" variant="h4">
                  {total === 1 && 'Found 1 result.'
                    ? total > 20 && 'Showing the top twenty results.'
                    : `Found ${total} results.`}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              {!total && !isLoading && searched &&
                <ErrorNotification dismissible title="There is no school that matches your search criteria." />
              }
              {data.length > 0 &&
                <DISearchResult
                  dischools={data}
                  searchParams={{ OrgName: name, Zip: zip, Country: country }}
                />
              }
              {((!total && !isLoading && searched) || (data.length > 0)) &&
                <>
                  <br></br>
                  <PrimaryCardButton className="cb-padding-8" onClick={() => setIsCreateModalOpen(true)}>
                    Not Found? Start a new Score Send Code Request.
                  </PrimaryCardButton>
                </>
              }
            </Grid>
          </>
        </Grid>
      }
    </Grid>
  );
};
export default DISearch;